import Box from "ds/components/Box";
import useIsFlowsIntegrationEnabled from "hooks/useIsFlowsIntegrationEnabled";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import { selectNavigationShowsExpandedContent } from "components/MainNavigation/selectors/navigationState";

import MainNavigationPinnedGroup from "../PinnedItems";
import MainNavigationSearchButton from "../SearchButton";
import MainNavigationAskButton from "../AskButton";
import styles from "./styles.module.css";
import MainNavigationLogo from "../Logo";
import MainNavigationSettingsButton from "../SettingsButton";
import MainNavigationButtonExpand from "../ButtonExpand";
import MainNavigationProductSwitcher from "./ProductSwitcher";

const MainNavigationHeader = () => {
  const showsExpandedContent = useMainNavigationStore(selectNavigationShowsExpandedContent);
  const { transitionClasses } = useMainNavigationFadeTransition(!!showsExpandedContent);
  const isFlowsIntegrationEnabled = useIsFlowsIntegrationEnabled();

  return (
    <Box
      className={styles.navigationHeader}
      direction="column"
      gap="medium"
      padding="0 0 medium"
      shrink="0"
    >
      <Box justify="between" align="center" padding="small 0">
        {/* With Flows on, the logo is folded into the product switcher trigger; otherwise it's
            the plain dashboard link. */}
        {isFlowsIntegrationEnabled ? <MainNavigationProductSwitcher /> : <MainNavigationLogo />}

        <Box gap="small" className={transitionClasses}>
          <MainNavigationSettingsButton />
          {showsExpandedContent && <MainNavigationButtonExpand />}
        </Box>
      </Box>

      <Box relative fullWidth>
        <MainNavigationSearchButton />
        <MainNavigationAskButton />
      </Box>
      <MainNavigationPinnedGroup />
    </Box>
  );
};

export default MainNavigationHeader;
